import Vue from 'vue'

/**
 * ブラウザ履歴を監視する vm クラス
 */
export default Vue.extend({
  data: () => ({
    current: {
      len: 0,
      key: '',
      name: '',
      path: ''
    }
  }),
  created () {
    // vm 起動時に popstate イベントを購読する
    // popstate イベントが発行されたら `update()` を実行する
    window.addEventListener('popstate', () => this.update())

    // 初回の update() を実行する
    this.update()
  },
  watch: {
    // $route が変更されたら `update()` を実行する
    $route: 'update',

    // current が変更されたら、history ストアの状態を更新する
    current: {
      deep: true,
      handler () {
        this.$store.commit('history/update', this.current)
      }
    }
  },
  methods: {
    /**
     * this.current を更新する
     */
    update () {
      // history.state がなければ、key を付加する
      if (!history.state) {
        history.replaceState({ key: performance.now().toFixed(3) }, '')
      }

      // this.current のプロパティを **個別** に更新する
      // 個別に更新することで、watch.history() の呼び出しが最適化されて
      // 重複しなくなる → 同じ内容のイベントを乱発しなくなる
      this.current.len = history.length
      this.current.key = history.state.key
      this.current.name = this.$route.name
      this.current.path = this.$route.fullPath
    }
  }
})
